import { Link } from 'react-router-dom';

export default function AboutPage() {
  return (
    <div className="min-h-screen bg-white">
      {/* Header */}
      <section className="bg-gradient-to-br from-blue-600 to-indigo-700 text-white">
        <div className="max-w-4xl mx-auto px-4 py-20 text-center">
          <h1 className="text-4xl md:text-5xl font-bold">About VSENDS</h1>
          <p className="mt-6 text-lg text-blue-100 max-w-2xl mx-auto">
            We're building the most intelligent email marketing platform in the world — powered by AI, designed for humans.
          </p>
        </div>
      </section>

      {/* Mission */}
      <section className="py-16">
        <div className="max-w-4xl mx-auto px-4">
          <h2 className="text-2xl font-bold text-gray-900 mb-6">Our Mission</h2>
          <p className="text-lg text-gray-600 leading-relaxed">
            Email marketing hasn't fundamentally changed in over a decade. Platforms are complex, time-consuming, and require expertise that most businesses don't have. We built VSENDS to change that.
          </p>
          <p className="text-lg text-gray-600 leading-relaxed mt-4">
            By combining powerful email marketing tools with intelligent AI automation, we make it possible for any business — regardless of size or technical ability — to create campaigns that convert, build automations that engage, and grow their audience with confidence.
          </p>
        </div>
      </section>

      {/* Values */}
      <section className="py-16 bg-gray-50">
        <div className="max-w-4xl mx-auto px-4">
          <h2 className="text-2xl font-bold text-gray-900 mb-8">Our Values</h2>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            {[
              { title: 'Simplicity First', desc: 'Complex problems deserve simple solutions. We design every feature to be intuitive and accessible.' },
              { title: 'AI That Helps, Not Replaces', desc: 'AI is a powerful assistant, not a replacement for human judgment. We design tools that augment your expertise.' },
              { title: 'Privacy by Design', desc: 'We build privacy into every feature. GDPR compliance is our foundation.' },
            ].map((value) => (
              <div key={value.title} className="p-6 bg-white rounded-xl border border-gray-200">
                <h3 className="font-semibold text-gray-900">{value.title}</h3>
                <p className="text-sm text-gray-600 mt-2">{value.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Company */}
      <section className="py-16">
        <div className="max-w-4xl mx-auto px-4">
          <h2 className="text-2xl font-bold text-gray-900 mb-6">Company Information</h2>
          <div className="bg-gray-50 rounded-xl p-8 space-y-4">
            <div>
              <p className="text-sm font-medium text-gray-500 uppercase">Trading Name</p>
              <p className="text-lg font-semibold text-gray-900">VSENDS</p>
            </div>
            <div>
              <p className="text-sm font-medium text-gray-500 uppercase">Legal Entity</p>
              <p className="text-lg font-semibold text-gray-900">V CAN RESOURCES LIMITED</p>
            </div>
            <div>
              <p className="text-sm font-medium text-gray-500 uppercase">Company Number</p>
              <p className="text-lg text-gray-900">13759348</p>
            </div>
            <div>
              <p className="text-sm font-medium text-gray-500 uppercase">Registered Office</p>
              <p className="text-lg text-gray-900">32 Abbey Drive, Dartford, England, DA2 7WP</p>
            </div>
          </div>
        </div>
      </section>

      {/* CTA */}
      <section className="py-16 bg-blue-600 text-white">
        <div className="max-w-4xl mx-auto px-4 text-center">
          <h2 className="text-2xl font-bold">Want to learn more?</h2>
          <p className="mt-2 text-blue-100">Get in touch with our team.</p>
          <div className="mt-6 flex flex-col sm:flex-row gap-4 justify-center">
            <Link to="/contact" className="px-8 py-3 bg-white text-blue-700 font-semibold rounded-xl hover:bg-blue-50 transition-colors">
              Contact Us
            </Link>
            <Link to="/login" className="px-8 py-3 border-2 border-white text-white font-semibold rounded-xl hover:bg-white/10 transition-colors">
              Try VSENDS Free
            </Link>
          </div>
        </div>
      </section>
    </div>
  );
}
